import { observable, action, computed } from 'mobx';
import isEmpty from 'lodash/isEmpty';
import trim from 'lodash/trim';
import { getManyHoursSpent } from '../../../../../services/UserService';

class TotalHourStore {
  constructor(organizationStore) {
    this.organizationStore = organizationStore;
  }

  @observable reporteesHours = [];

  @action async getReporteesHours(users, signal) {
    if (!users || users.length === 0) {
      return {};
    }
    let hourData;
    try {
      hourData = await getManyHoursSpent(users, signal);
    } catch (err) {
      if (
        err?.name === 'AbortError' ||
        err?.name === 'CanceledError' ||
        err?.code === 'ERR_CANCELED'
      ) {
        return {};
      }
      throw err;
    }
    const transformedData = {};
    users.forEach((username) => {
      transformedData[username] = {
        username,
        count: hourData.hours_spent[username].toFixed(2),
      };
    });
    this.reporteesHours = Object.values(transformedData);
    return Object.values(transformedData);
  }

  // Transform raw data to fit datatable
  @computed get filteredData() {
    const selectedUsers = this.organizationStore.selectedUsersByManagerList;
    const filteredHours = this.reporteesHours.filter((a) =>
      selectedUsers.includes(a.username),
    );

    return filteredHours.map((item) => {
      const userObject = this.organizationStore.getUserByUsername(
        item.username,
      );

      return {
        ...item,
        username: !isEmpty(trim(userObject.preferred_name))
          ? `${item.username} (${userObject.preferred_name})`
          : `${item.username}`,
      };
    });
  }
}

export default TotalHourStore;
